import { FC } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

const RenderChildren: FC = (props) => <>{props.children}</>;
const RequireAuthentication = withAuthenticationRequired(RenderChildren);

export default RequireAuthentication;
